import { render, staticRenderFns } from "./subChannelStatis.vue?vue&type=template&id=6808558e&scoped=true&"
import script from "./subChannelStatis.vue?vue&type=script&lang=js&"
export * from "./subChannelStatis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6808558e",
  null
  
)

export default component.exports